require("./wdh-legacy/cookies/js/corporate-template/component-cookies.js");